import React, { useState } from 'react';
import Functions from '../../api/Functions';
import Loading from '../generalComponets/Loading';

function Activities() {
  const [showProcess, setShowProcess] = useState(false);

  const copyNotifications = () => {
    setShowProcess(true);
    Functions.copyLastNotificationsToActivities()
      .then(() => {
        setShowProcess(false);
      })
      .catch(() => {
        setShowProcess(false);
      });
  };

  return (
    <div className="container">
      <div className="title-section">Activities</div>
      {showProcess ? <Loading /> : <div />}
      <div className="row">
        <div className="col l3 m6 s12">
          <div className="card horizontal">
            <div className="card-stacked">
              <div className="card-content">
                <p>Copy Last Notifications</p>
              </div>
              <div className="card-action">
                <button className="waves-effect waves-teal btn-flat action-link" onClick={copyNotifications}>Copy Last Notifications</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Activities;
